import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalComponent from 'react-modal';
import ClassList from 'class-list';

import '../sass/Modal.sass';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.wrapper = ClassList(document.getElementById('wrapper'));
  }

  componentDidUpdate() {
    if (this.props.isOpen) {
      this.wrapper.add('overflow-hidden');
    } else {
      this.wrapper.remove('overflow-hidden');
    }
  }

  render() {
    return (
      <ModalComponent
        isOpen={this.props.isOpen}
        ariaHideApp={false}
        overlayClassName="sg-overlay z-20 fixed inset-0 w-screen h-screen-real overflow-y-auto touch"
        className="sg-modal z-30 inset-0 w-screen md:rounded mx-auto md:my-8 min-h-screen-real md:min-h-0 bg-white md:max-w-xl pt-4">
        <header className="py-4 px-4 md:px-8 relative">
          <div className="relative">
            <h1 className="text-3xl font-black font-serif text-gray-900">{ this.props.title }</h1>
            <button className="text-3xl absolute top-0 right-0 py-2 px-3" onClick={this.props.onClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <path d="M23 20.168l-8.185-8.187 8.185-8.174-2.832-2.807-8.182 8.179-8.176-8.179-2.81 2.81 8.186 8.196-8.186 8.184 2.81 2.81 8.203-8.192 8.18 8.192z"/>
              </svg>
            </button>
          </div>
        </header>
        <main className="py-4 px-4 md:px-8">
          { this.props.children }
        </main>
      </ModalComponent>
    );
  }
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

Modal.defaultProps = {
  isOpen: false,
};

export default Modal;